import React, { useState, useEffect } from "react";
import * as styles from "../components/SecretLayout.module.css";
import { Triangle } from "react-loader-spinner";
import { Logo } from "../components/Logo";
import Seo from "../components/Seo";

const SecretContents = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 100);
  }, [isVisible]);
  const classes = isVisible
    ? `${styles.base}`
    : `${styles.base} ${styles.hidden}`;
  return (
    <div className={classes}>
      <div>
        <Logo text="Log" url="/secret" />
      </div>
      {children}
    </div>
  );
};

const SecretLayout = ({ children }) => {
  const [skipLoad, setSkipLoad] = useState(() => {
    if (typeof window !== "undefined") {
      return window.localStorage.getItem("skipLoad") === "true";
    }
    return false;
  });
  useEffect(() => {
    if (!skipLoad) {
      setTimeout(() => {
        setSkipLoad(true);
        if (typeof window !== "undefined") {
          window.localStorage.setItem("skipLoad", "true");
        }
      }, 1500);
    }
  }, [skipLoad]);
  return (
    <>
      <Seo title="Secret" />
      <div className={styles.background}></div>
      {skipLoad ? (
        <SecretContents children={children} />
      ) : (
        <div className={styles.loader}>
          <Triangle width={200} height={200} color="black" />
        </div>
      )}
    </>
  );
};

export default SecretLayout;
